<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue';
const { proxy: vm } = getCurrentInstance();

const reasons = computed({
  get: () => vm.$store.state.profile.accountDelete.feedbackReasons,
  set: value => {
    vm.$store.commit('profile/accountDelete/updateFeedbackReasons', value);
  }
});

const details = computed({
  get: () => vm.$store.state.profile.accountDelete.feedbackDetails,
  set: value => vm.$store.commit('profile/accountDelete/setFeedbackDetails', value)
});
</script>

<template>
  <div>
    <v-checkbox
      v-for="(reason, key) in $t('profile.removeDialog.feedback.checkboxes')"
      :key="`accounte-delete-checkbox_${key}`"
      v-model="reasons"
      :label="reason"
      :value="key"
      multiple
      :error="reasons.length === 0"
    ></v-checkbox>
    <template v-if="reasons.length > 0">
      <label for="deleteFeedbackDetails" class="mt-4">{{
        $t('profile.removeDialog.feedback.detailsLabel')
      }}</label>
      <v-textarea
        id="deleteFeedbackDetails"
        v-model="details"
        flat
        solo
        auto-grow
        rows="4"
        hide-details
      />
    </template>
  </div>
</template>
